import React, { CSSProperties } from 'react';
import { useNavigate } from 'react-router-dom';

 

const ErrorPage: React.FC = () => {
      const navigate = useNavigate();
  return (
    <div style={styles.container}>
 
      <div style={styles.card}>
  
        <svg xmlns="http://www.w3.org/2000/svg" style={styles.icon} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>


        <h1 style={styles.heading}>Oops, Something Went Wrong</h1>
        

        <p style={styles.message}>
          We're sorry, an unexpected error occurred. Please try again later.
        </p>

        <span 
          style={styles.button}
           onClick={()=>{
            navigate(-1)
        }}
        >
          Go Back
        </span>
      </div>
    </div>
  );
};


const styles: { [key: string]: CSSProperties } = {
  container: {
    backgroundColor: '#fff',
    minHeight: '100vh',
    padding: '1rem',
    fontFamily: 'Inter, sans-serif',
    display: 'flex',
    flexDirection: 'column',
    justifyContent:'center',
    alignItems: 'center',
  },
  header: {
    width: '100%',
    maxWidth: '600px',
    padding: '1rem',
  },
  backButton: {
    display: 'flex',
    alignItems: 'center',
    color: '#333',
    textDecoration: 'none',
    fontWeight: '500',
    fontSize: '1rem',
  },
  backIcon: {
    height: '1.5rem',
    width: '1.5rem',
    marginRight: '0.5rem',
  },
  card: {
    backgroundColor: 'white',
    padding: '2rem',
    borderRadius: '0.75rem',
    width: '100%',
    textAlign: 'center',
    marginTop: '2rem',
  },
  icon: {
    height: '4rem',
    width: '4rem',
    margin: '0 auto 1.5rem',
    color: '#FF6347',
  },
  heading: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    marginBottom: '0.5rem',
    color: '#333'
  },
  message: {
    color: '#666',
    fontSize: '1rem',
    marginBottom: '2rem'
  },
  button: {
    display: 'inline-block',
    backgroundColor: '#1E88E5',
    color: 'white',
    fontWeight: '600',
    padding: '0.75rem 2rem',
    borderRadius: '0.5rem',
    transition: 'all 0.3s ease',
    textDecoration: 'none',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  }
};

export default ErrorPage;
